import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddEnquiryRes;
export const AddEnquiryTodo = createAsyncThunk('AddEnquiry', async (data) => {
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL + 'admin_add_subscription',
            data: {
                // "email": data.email,
                "mobile": data.contact_nu,
            },
            headers: { "Content-Type": "application/json" }
        })
        return AddEnquiryRes = res.data
        
    } catch (error) {
        return AddEnquiryRes = error.response.data
    }
})
